import icStakeLong from 'assets/img/ic_stake_long.png';
import icStakeShort from 'assets/img/ic_stake_short.png';
import icStakeFlexible from 'assets/img/ic_stake_flexible.png';
import { StakingPlan } from 'src/models';
export const stakingPlanMap = {
  [StakingPlan.FLEXIBLE]: {
    icon: icStakeFlexible,
    icStyle: 'flexible'
  },
  [StakingPlan.ONE_YEAR]: {
    icon: icStakeLong,
    icStyle: 'fixed'
  },
  [StakingPlan.SIX_MONTHS]: {
    icon: icStakeShort,
    icStyle: 'fixed'
  }
};